import { array, object, string } from "yup";

const bulkCartRowSchema = object()
  .shape({
    product_id: string().required("Please select a task"),
    action: string().required("Please select an action"),
    season: string().required("Please select a season"),
  })
  .noUnknown(false);

export const bulkCartActionSchema = object({
  rows: array().of(bulkCartRowSchema).min(1, "At least one row is required"),
});
